export const nameInitials = (name) => {
  const [firstName, lastName] = name.split(" ");

  if (firstName && lastName) {
    return `${firstName[0]}. ${lastName}`;
  }
  if (firstName && !lastName) {
    return firstName;
  }
  return lastName;
};
